<div class="modal-header">
    <h4 class="modal-title">Training Details</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
    <p><strong>Company:</strong> {{ row.companyName }}</p>
    <p><strong>Email:</strong> {{ row.email }}</p>
    <p><strong>Employee:</strong> {{ participantName }}</p>
    <p><strong>Status:</strong> {{ row.status }}</p>
    <p><strong>Invited On:</strong> {{ row.invitedOn | date: 'medium' }}</p>
    @if (row.isOverdue) {
        <p><strong>Overdue:</strong> <span class="badge text-bg-danger">Yes ({{ row.daysSinceInvited }} days since invite)</span></p>
    }

    @for (module of row.modules; track module.moduleId) {
        <div class="border rounded p-3 mb-3">
            <h5>{{ module.moduleTitle }}</h5>
            @if (module.isCompleted) {
                <p class="mb-2">
                    Completed by {{ module.completedFirstName }} {{ module.completedLastName }} ({{ module.completedCompanyName }})
                    on {{ module.completedOn | date: 'medium' }} — Score: {{ module.scoreCorrect }}/{{ module.scoreTotal }}
                </p>
                <ul class="mb-0">
                    @for (answer of module.answers; track $index) {
                        <li class="mb-2">
                            <div>{{ answer.questionText }}</div>
                            <div>
                                Selected: {{ answer.selectedAnswer }}
                                @if (answer.isCorrect) {
                                    <span class="text-success">(Correct)</span>
                                } @else {
                                    <span class="text-danger">(Incorrect — correct: {{ answer.correctAnswer }})</span>
                                }
                            </div>
                        </li>
                    }
                </ul>
            } @else {
                <p class="text-muted mb-0">Not completed yet.</p>
            }
        </div>
    }
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.close()">Close</button>
</div>
